import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";

import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import SectionBox from "../../components/SectionBox";

import Variables from "../../variables/variables.json";

import DlaMieszkancaSection1PL from "../../content/przyjaznedeklaracje/dla-mieszkanca/section-1_pl.mdx";
import DlaMieszkancaSection2PL from "../../content/przyjaznedeklaracje/dla-mieszkanca/section-2_pl.mdx";
import DlaMieszkancaSection3PL from "../../content/przyjaznedeklaracje/dla-mieszkanca/section-3_pl.mdx";
import InputMaterial from "../../components/material/Input";
import TextareaMaterial from "../../components/material/Textarea";
import TranslatedMessage from "../../components/TranslatedMessage";
import DeclarationBoxItemMinutes from "../../components/DeclarationBoxItemMinutes";

export default function DlaMieszkanca(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "dlamieszkanca";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="carousel" breadcrumbsLayout="dark">
			<Section mdx lightdark>
				<DlaMieszkancaSection1PL />
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wybierzjednadeklaracje.title">
				<DeclarationBox miasto={Miasto} center>
					{Variables.miasta[Miasto].declarationBoxItem[Podatek].map((declarationBoxItem, index) => {
						return (
							<DeclarationBoxItem
								miasto={Miasto}
								podatek={declarationBoxItem.title}
								key={index}
								soon={declarationBoxItem.soon && true}
							/>
						);
					})}
					<DeclarationBoxItemMinutes />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} context={Podatek} />
			</Section>

			<Section mdx lightdark>
				<DlaMieszkancaSection2PL />
			</Section>

			<Section primary title="sections.wynikukalkulacji.title">
				<SectionBox section="wynikukalkulacji" />
			</Section>

			<Section mdx lightdark>
				<DlaMieszkancaSection3PL />
			</Section>

			<Section title="sections.poradniki.title">
				<SectionBox section="poradniki" light box link />
			</Section>

			{/* <Section lightdark title="sections.zostawopinie.title">
        <p className="text-center">
          <TranslatedMessage id="sections.zostawopinie.subtitle" />
        </p>
        <ContactForm>
          <legend className="sr-only">Treść wiadomości:</legend>
          <div className="pd-contact-form__input">
            <TextareaMaterial
              name="tresc_wiadomosci"
              rows="5"
              required
              placeholder="Treść wiadomości">
              Treść wiadomości
            </TextareaMaterial>
          </div>
        </ContactForm>
      </Section> */}
		</SectionLayout>
	);
}
